/*
  Hover image scrubbing on product cards (like digitec.ch).
  Media elements with data-usp-hover='url1|url2|…' (snippet usp-hover-images) show the photo that matches the
  mouse position: left edge = first photo, right edge = last photo. Thin bars at the bottom show which photo
  is visible. Leaving the photo shows the first photo again. Only for a real mouse; touch keeps the first photo.
*/
(() => {
  const ATTR = 'data-usp-hover';
  const state = new WeakMap();

  function setup(media) {
    const img = media.querySelector('img');
    const urls = (media.getAttribute(ATTR) || '').split('|').filter(Boolean);
    if (!img || urls.length < 2) return null;

    const bars = document.createElement('span');
    bars.className = 'usp-hover-bars';
    bars.setAttribute('aria-hidden', 'true');
    urls.forEach(() => bars.appendChild(document.createElement('span')));
    bars.firstChild.classList.add('is-active');
    media.appendChild(bars);

    // load the other photos once, so switching is instant
    const loaded = urls.map((u, i) => {
      if (i === 0) return true;
      const pre = new Image();
      pre.decoding = 'async';
      pre.src = u;
      return pre;
    });

    const s = {
      img,
      urls,
      bars,
      loaded,
      index: 0,
      src: img.getAttribute('src'),
      srcset: img.getAttribute('srcset'),
    };
    state.set(media, s);
    return s;
  }

  function show(media, s, i) {
    if (i === s.index) return;
    s.index = i;
    if (i === 0) {
      if (s.srcset) s.img.setAttribute('srcset', s.srcset);
      s.img.setAttribute('src', s.src);
    } else {
      s.img.removeAttribute('srcset');
      s.img.setAttribute('src', s.urls[i]);
    }
    [...s.bars.children].forEach((b, n) => b.classList.toggle('is-active', n === i));
  }

  function onMove(e) {
    if (e.pointerType !== 'mouse') return;
    const media = e.target.closest && e.target.closest('[' + ATTR + ']');
    if (!media) return;
    const s = state.get(media) || setup(media);
    if (!s) return;
    media.classList.add('is-hovering');
    const r = media.getBoundingClientRect();
    const x = Math.min(Math.max(e.clientX - r.left, 0), r.width - 1);
    show(media, s, Math.floor((x / r.width) * s.urls.length));
  }

  function reset(media) {
    const s = state.get(media);
    media.classList.remove('is-hovering');
    if (s) show(media, s, 0);
  }

  document.addEventListener('pointermove', onMove, { passive: true });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const media = e.target.closest && e.target.closest('[' + ATTR + ']');
    if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
    reset(media);
  }, { passive: true });

  // first photo is back when the user returns with the browser's back button
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[' + ATTR + '].is-hovering').forEach(reset);
  });
})();
